"use client";
import Link from "next/link";
import classes from "./side-nav-link.module.css";
import { usePathname } from "next/navigation";

export default function SideNavLink({ href, children }) {
  const path = usePathname();

  const navStyle =
    "text-sm text-sm hover:text-blue-500 transition duration-300 font-thin pt-1";

  return (
    <Link
      className={path.startsWith(href) ? classes.active2 : navStyle}
      href={href}
    >
      {children}
    </Link>
  );
}
